<template>
  <div>
    <MainForm
     :name="FORM_NAMES.cardReader"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title=""
    >
    <!-- <div v-if="isSalesAgent"> -->
     
    <!-- </div> -->
      <StepModel
        :ui="uiBasePersonal"
      :name="STEP_NAMES.cardReader"
      ui-title=""
      ui-subtitle=""
     ui-hide-button
    >
      <FieldsetModel :ui="uiNoticeFieldset" :name="FIELDSET_NAMES.customerConsent">
         <p class="saving" id="spinner2">
              <span class="dot"></span>
              <span class="dotText">Give us few seconds...</span>
            </p>
      </FieldsetModel>

      </StepModel>

     

     

     
    </MainForm>

  
    
  </div>

</template>

<script>
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import store from "@/store";
import StepOtp from "@/forms/components/shared/steps/otp";
import StepContact from "@/forms/components/shared/steps/contact-verification";
import FIELD_NAMES from "@/forms/constants/field-names";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import {
  SET_SPENDING,
  SET_SALARY_RECEIVE,
  SET_REWARD_TYPE,
  SET_CASH_BACK_POINT,
  SET_TEN_TO_TWENTY_FIVE,
  SET_MORE_THAN_TWENTY_FIVE,
  SET_LOAN_TYPE,
   SET_CUSTOMER_CONSENT,
} from "@/lib/constants/mutations";
// Services
import flowManager from "@/lib/services/flow-manager";
import otpServiceReferal from "@/forms/api/services/otp-referral";
import sleep from '@/forms/helpers/sleep';
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import router from "@/router";
// Ui Components
import {
 
  // InputText,
  Choice,
  Button,
  ProductCover,
  SidePanel,
  Grid,
  PlainText
} from "@dunia/ui";

// Utils
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import automationApiService from "@/forms/api/services/automation-api";
// Helpers

// Constants
import {
  SPENDING,
  YESNO,
  INCOME,
  CARD_USE,
  CARD_USE_LONG,
  REWARDSTYPE,
  FEATURES_NBC_CARDS,
  //FIELD_NAMES
} from "@/forms/constants/nbc-stp-logic";

export default {
  name: "NBC",

  mixins: [FormComponentMixin],

  components: {
   
    // Components
    MainForm,
    StepModel,
    FieldsetModel,
    // InputText,
    Choice,
    UiWrapper,
    Button,
    // Pages
    ProductCover,
    SidePanel,
    Grid,
    PlainText,
    StepOtp,
    StepContact
  },

  data: () => ({
    panelVisible: -1,
    ___readyToAnimate: false,
    SPENDING,
    YESNO,
    INCOME,
    CARD_USE,
    CARD_USE_LONG,
    REWARDSTYPE,
    FEATURES_NBC_CARDS,
   // FIELD_NAMES
  }),
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  updated: function() {
   
  },
  computed: {
    // show if
    // - 1st answer is Paying straight, or
    // - 1st answer is Deferred and the 2nd is also answered
   
     
  },

  methods: {
    finishNBC() {
      flowManager.goToNextStep({ stepToGo: "show-cards" });
    },

    actionWrapper(cb, ...args) {
      return () => cb(...args);
    },

    fieldValues(fieldname) {
      const { $store } = this;

      return getValueByFieldName($store.state.formData.values, fieldname);
    },

    // benefits panel logic
    isPanelVisible(key) {
      return key === this.panelVisible;
    },

    showPanel(key) {
      this.panelVisible = key;
    },

    hidePanel() {
      this.panelVisible = -1;
    },

    showBest(key, label) {
      if (key === 0) {
        return label;
      }
      return null;
    },
     gotToWelcome(callback) {
  var product = this.fieldValues(FIELD_NAMES.product);
        var formToGo = "";
        // if (product) {
        //   if (product.toLowerCase() === "personal loan".toLowerCase()) {
        //     formToGo = "Deem | Loan Application";
         // } else if (product.toLowerCase() === "credit card") {
            formToGo = "STP Card";
          //}
       // }
         callback();
        if (formToGo != "") {
          router.goToFormByName(formToGo, {
            stepNameToInit: stepToGo
          });
        }
    },
     
  },
 
async  mounted() {
    this.___readyToAnimate = true;
    var currentStep = this.STEP_NAMES.cardReader;

    await automationApiService.getAutomationApi(currentStep, this);
       var formToGo = "";
        // if (product) {
        //   if (product.toLowerCase() === "personal loan".toLowerCase()) {
        //     formToGo = "Deem | Loan Application";
         // } else if (product.toLowerCase() === "credit card") {
            formToGo = "Eid Card";
          //}
       // }
        
        if (formToGo != "") {
          router.goToFormByName(formToGo, {
            stepNameToInit: 'welcome'
          });
        }
  }
};
</script>
<style scoped>
#linkButton {
  background-color: transparent;
  border: none;
}
#linkButton > a {
  position: relative;
  color: #000000;
  text-decoration: underline;
  color: #551a8b;
  font-weight: bold;
}

#linkButton > a:hover {
  color: #551a8b;
}
#linkButton > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: #551a8b;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}
#linkButton > a:hover:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
@media (max-width: 768px) {
  [class="hyperlinkCss"] {
    font-size: 15px;
    text-decoration: underline;
    color: #551a8b;
    font-weight: bold;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
.resendText {
  color: #9e9e9e;
}
</style>
